/*global jQuery, SimpleBar, YT, DM, vidible*/
(function ($) {
    'use strict';

    $.fn.topVideos = function (option/*, varArgs*/) {
        var args = Array.prototype.slice.call(arguments, 1);

        return this.each(function () {
            var $element = $(this);
            var ctrl = $element.data('topVideos');

            if (!ctrl) {
                var opts = $.extend({},
                    $.fn.topVideos.defaults,
                    typeof option === 'object' && option
                );

                $element.data('topVideos', (ctrl = new TopVideos(this, opts)));
            }

            if (typeof option === 'string') {
                ctrl[option].apply(ctrl, args);
            }
        });
    };

    $.fn.topVideos.defaults = { };

    function TopVideos(element, options) {
        this.init(element, options);
    }

    TopVideos.lastUid = 0;

    TopVideos.prototype = {
        constructor: TopVideos,

        // Properties
        uid: 0, // Unique id attached to each top video instance
        $playbackArea: null,
        $videosList: null,
        $scrollAnchor: null,
        $thumbsScrollContent: null,
        simpleBar: null,

        // Contains current youtube player if there is such
        youtubePlayer: null,
        vidiblePlayer: null,
        dailyMotionPlayer: null,

        autoClickDirty: false,
        scrollinDirty: false,
        nextPlaysMuted: true,

        // Methods
        init: function (element, options) {
            this.uid = TopVideos.lastUid++;
            this.options = options;
            this.$element = $(element);
            this.$playbackArea = this.$element.find('.top-videos__play');
            this.$videosList = this.$element.find('.top-videos__list__content');

            this.simpleBar = new SimpleBar(this.$videosList[0]);
            this.$thumbsScrollContent = $(this.simpleBar.getContentElement());

            // Create reused method closures
            this._onEmbedLoaded = this._onEmbedLoaded.bind(this);
            this._onWindowBlur = this._onWindowBlur.bind(this);
            this._onPlayerReady = this._onPlayerReady.bind(this);
            this._onPlayerEnded = this._onPlayerEnded.bind(this);
            this._onEmbedFirstClick = this._onEmbedFirstClick.bind(this);
            this._trackVideo.cardLinkClick = this._trackVideo.cardLinkClick.bind(this);

            // Handle resize logic
            this._validateSize();
            $(window).on('resize', this._validateSize.bind(this));

            // Listeners
            this.$videosList.on('click', '.card a', this._onPlayVideoClick.bind(this));
            this.$videosList.on('wheel', this._onMouseWheel.bind(this));
            this.$element.on('click', '[data-top-videos]', this._onDataAction.bind(this));
            this.$thumbsScrollContent.on('scroll', this._onThumbsScrollChange.bind(this));

            this._activateCard('first', false);
            this._attachScrollInAnchor();
        },

        // Cleans global listeners
        dispose: function() {
            if (this.player) {
                this.destroy();
                this.player = null;
            }
        },

        isNarrow: function() {
          return this.$element.hasClass('top-videos--narrow');
        },

        /**
         * @param {string} url
         * @param {boolean} autoPlay
         */
        playVideo: function (url, autoPlay) {
            var $playbackArea = this.$playbackArea;

            if (autoPlay) {
                // Helpful for unknown player types
                url += url.lastIndexOf('?') >= 0 ? '&autoplay=1' : '?autoplay=1';

                if (this.nextPlaysMuted) {
                    url += '&mute=1';
                }
            }

            $playbackArea.data('video-meta', {
               url: url, autoPlay: autoPlay
            });

            $.get('/video-embed' + url).then(function (content) {
                $playbackArea.css('opacity', 0);
                $playbackArea.html(content).promise().done(this._onEmbedLoaded);
                $playbackArea.animate({opacity: 1});
            }.bind(this));
        },

        /**
         * Hooks a vidible player. Called externally from vidible.js
         */
        hookVidible: function(player) {
            this.player.activate(player);
        },

        /** @private */
        _onEmbedLoaded: function() {
            var $embed = this.$playbackArea.find('.embed-container');
            var options = {
                onReady: this._onPlayerReady,
                onEnded: this._onPlayerEnded,
            };

            if (this.player) {
                this._validateMuteState();

                // TODO: Reuse the player instance for smoother experience
                // We can do that when the next video is the same type
                this.player.destroy();
                this.player = null;
            }

            switch (this._detectEmbedType()) {
                case 'youtube':
                    this.player = $embed.topVideoYoutube(options).data('topVideoYoutube');
                    break;
                case 'vidible':
                    this.player = $embed.topVideoVidible(options).data('topVideoVidible');
                    break;
                case 'dailymotion':
                    this.player = $embed.topVideoDailyMotion(options).data('topVideoDailyMotion');
                    break;
                default:
                    this.player = $embed.topVideoUnknown(options).data('topVideoUnknown');
            }

            if (this.scrollinDirty) {
                this._onVisibleEnough();
            } else if (this.nextPlaysMuted) {
                this.player.mute();
            }
        },

        /** @private */
        _detectEmbedType: function() {
            var $playbackArea = this.$playbackArea;
            var $youtubePlayer = $playbackArea.find('#ytplayer');
            var $iframe = $playbackArea.find('iframe');
            var playerType = 'unknown';

            if ($youtubePlayer.length) {
                playerType = 'youtube';
            } else if ($iframe.filter('[src*="video.huffingtonpost.it"]').length) {
                playerType = 'italy';
            } else if ($iframe.data('provider') === 'dailymotion') {
                playerType = 'dailymotion';
            } else if ($playbackArea.find('[data-provider="vidible"]').length) {
                playerType = 'vidible';
            }

            console.log('Top Videos - embed type', playerType);
            return playerType;
        },

        /** @private */
        _onPlayerReady: function() {
            var $embedContainer = this.$playbackArea.find('.embed-container');
            var player = this.player;

            // Make sure the player has actual dimensions
            if (player.playerHeight > 0) {
                var isSquare = player.playerWidth === player.playerHeight;
                var contentHeight = isSquare ? player.playerHeight : '';

                this.$playbackArea.css({
                    'min-height': contentHeight,
                    'padding-bottom': isSquare ? '30px' : '0'
                });

                $embedContainer.css('padding-bottom', contentHeight);
            }
        },

        /** @private */
        _listenForPlayerClick: function (enabled) {
            if (enabled) {
                // Detect player clicks.
                window.addEventListener('blur', this._onWindowBlur); // When there's an iframe that's the only way to detect
                // Capture phase increases our chances of catching the click before the content
                this.$playbackArea[0].addEventListener('click', this._onEmbedFirstClick, true);
            } else {
                window.removeEventListener('blur', this._onWindowBlur);
                this.$playbackArea[0].removeEventListener('click', this._onEmbedFirstClick, true);
            }
        },

        /** @private */
        _onPlayerEnded: function(newState) {
            this._autoPlayNext();
        },

        _autoPlayNext: function() {
            var videoUrl = this._activateCard('next', true);

            if (videoUrl) {
                this._trackVideo.autoPlayNext(videoUrl);
            }
        },

        /** @private */
        _validateMuteState: function() {
            if (this.nextPlaysMuted) {
                this.nextPlaysMuted = this.player.isMuted;
            }
        },

        /** @private */
        _validateSize: function() {
            var $element = this.$element;
            var elementWidth = this.$element.outerWidth();

            if (elementWidth > 1024) {
                // Wide version
                $element.removeClass('top-videos--narrow').addClass('top-videos--wide');
            } else {
                // Narrow version
                $element.removeClass('top-videos--wide').addClass('top-videos--narrow');
            }
        },

        /** @private */
        _onPlayVideoClick: function (event) {
            this.nextPlaysMuted = false; // User requested next video. Don't play it muted.
            event.preventDefault();
            var videoUrl = this._activateCard($(event.target).closest('.card'), true);

            if (videoUrl) {
                this._trackVideo.afterClick(videoUrl);
                this._trackVideo.cardLinkClick(event.target);
            }

            return false;
        },

        _onMouseWheel: function(event) {
            if (this.isNarrow()) {
                // Turn on horizontal scrolling with mouse wheel
                var delta = event.originalEvent.deltaY;
                var contentElement = this.simpleBar.getContentElement();

                contentElement.scrollLeft += delta;
                event.preventDefault();
                event.stopPropagation();
            }
        },

        _onDataAction: function(e) {
            var action =  $(e.currentTarget).data('top-videos');
            var scrollChange = 0;

            switch (action) {
                case 'prev':
                    scrollChange = -80;
                    break;
                case 'next':
                    scrollChange = 80;
                    break;
            }

            if (scrollChange !== 0) {
                var scrollContent = this.simpleBar.getContentElement();
                var $scrollContent = $(scrollContent);

                $scrollContent.stop(true).animate({
                    scrollLeft: scrollContent.scrollLeft + scrollChange
                }, 200);
            }
        },

        _onThumbsScrollChange: function(e) {
            var scrollContent = e.currentTarget;
            var viewportSize = scrollContent.clientWidth;
            var scrollSize = scrollContent.scrollWidth;
            var atEnd = scrollSize - viewportSize === scrollContent.scrollLeft;
            var atStart = scrollContent.scrollLeft === 0;

            this.$element.toggleClass('top-videos--scroll-start', atStart);
            this.$element.toggleClass('top-videos--scroll-end', atEnd);
        },

        /**
         * @param {string|jQuery} element
         * @returns jQuery
         * @private
         */
        _elementToCard: function(element) {
            switch (element) {
                case 'first':
                    return this.$cards.first();
                case 'next':
                    return this.$activeCard.next('.card');
                default:
                    return $(element).closest('.card');
            }
        },

        get $activeCard() {
            return this.$videosList.find('.card--active');
        },

        get $cards() {
            return this.$videosList.find('.card');
        },

        _attachScrollInAnchor: function() {
            var $element = this.$element;
            this.$scrollAnchor = $('<div class="top-videos__scroll-in-anchor"></div>').appendTo($element);

            if (this.$scrollAnchor.sonar()) {
                this._onVisibleEnough();
            } else {
                this.$scrollAnchor.on('scrollin', this._onVisibleEnough.bind(this));
            }
        },

        _onVisibleEnough: function() {
            // We care only once for this event.
            this.$scrollAnchor.off('scrollin');

            if (this.player) {
                this.scrollinDirty = false;
                var $element = this.$element;
                var autoplay = $element.data('play-first');
                var mute = $element.data('mute-first') === 1;

                if (autoplay === 'forceOn' || autoplay === 'default') {
                    if (mute) {
                        this.player.mute();
                    }

                    // Update video meta to match autoplay logic
                    var videoMeta = this.$playbackArea.data('video-meta');
                    videoMeta.autoPlay = true;

                    // Logic will apply only for know player types.
                    // Unknown player doesn't auto play.
                    this.player.play();
                    this._trackVideo.autoPlayFirst(videoMeta.url);
                } else {
                    // Autoplay is not enabled. Detect first video click
                    this._listenForPlayerClick(true);
                }
            } else {
                this.scrollinDirty = true;
            }
        },

        /**
         * @param element
         * @param {boolean} autoPlay
         * @return {string} video url
         * @private
         */
        _activateCard: function (element, autoPlay) {
            var $card = this._elementToCard(element);
            var videoUrl = null;

            if ($card.length) {
                var $link = $card.find('a').first();
                videoUrl = $link.attr('href');

                $card.siblings().removeClass('card--active');
                $card.addClass('card--active');

                autoPlay = autoPlay !== false;

                if (autoPlay) {
                    // If a video is on autoplay mode scroll it into view
                    $card[0].scrollIntoView({behavior: 'smooth', block: 'nearest'});
                }

                this.playVideo(videoUrl, autoPlay);
            } else {
                // Last card was reached. Remove play status and do nothing
                this.$cards.removeClass('card--active');
            }

            this._verifyActiveIndex();
            return videoUrl;
        },

        _verifyActiveIndex: function() {
            var cardIndex = this.$cards.index(this.$activeCard);
            var $element = this.$element;

            if (cardIndex === 0) {
                $element.removeClass('top-videos--last').addClass('top-videos--first');
            } else if (cardIndex <= 0 || cardIndex === this.$cards.length - 1) {
                $element.removeClass('top-videos--first').addClass('top-videos--last');
            } else {
                $element.removeClass('top-videos--first top-videos--last');
            }
        },

        /**
         * Will be called when autoplay is disabled and the user click on the first video.
         * @private
         */
        _onEmbedFirstClick: function(e) {
            this._listenForPlayerClick(false);

            /** @type {{url: string, autoPlay: boolean}} */
            var videoMeta = this.$playbackArea.data('video-meta');

            if (!videoMeta.autoPlay) {
                // Video didn't start automatically when loaded. Track start on click.
                // It was a video without autoPlay user clicked manually to start it
                this._trackVideo.afterClick(videoMeta.url);
            }
        },

        _onWindowBlur: function(e) {
            if (!this.autoClickDirty && document.activeElement instanceof HTMLIFrameElement) {
                var $embedFrame = this.$playbackArea.find('iframe');

                if ($embedFrame.length && $embedFrame[0] === document.activeElement) {
                    this._onEmbedFirstClick(e);
                }
            }
        },

        /** @private */
        _trackVideo: {
            autoPlayFirst: function trackVideo_autoPlayFirst(videoUrl) {
                console.log('Top Videos - auto play first:', videoUrl);

                if (window.RapidInstance) {
                    window.RapidInstance.beaconEvent('simple', {
                        _R: videoUrl,
                        expn: 'autoplay-first',
                        navtype: 'client'
                    }, 'top-videos');
                }
            },

            afterClick: function trackVideo_afterClick(videoUrl) {
                console.log('Top Videos - after click:', videoUrl);

                if (window.RapidInstance) {
                    window.RapidInstance.beaconEvent('simple', {
                        _R: videoUrl,
                        expn: 'click-play',
                        navtype: 'client'
                    }, 'top-videos');
                }
            },
            autoPlayNext: function trackVideo_autoPlayNext(videoUrl) {
                console.log('Top Videos - auto play next:', videoUrl);

                if (window.RapidInstance) {
                    window.RapidInstance.beaconEvent('simple', {
                        _R: videoUrl,
                        expn: 'auto-play',
                        navtype: 'client'
                    }, 'top-videos');
                }
            },
            cardLinkClick: function trackVideo_cardLinkClick(linkEl) {
                var $link = $(linkEl);
                var $card = $link.closest('.card');
                var pValue = this.$cards.index($card);
                var $rapidSec = this.$element.closest('[data-rapid-sec]');
                var rapidSec, secData;

                if ($rapidSec.length) {
                    try {
                        secData = JSON.parse($rapidSec.attr('data-rapid-sec'));
                    } catch (e) {
                        secData = null;
                    }

                    if (secData) {
                        // Extract the rapid section key
                        for (var key in secData) {
                            if (secData.hasOwnProperty(key)) {
                                rapidSec = key;
                                break;
                            }
                        }
                    }
                }

                if (window.RapidInstance) {
                    window.RapidInstance.beaconClick(
                        rapidSec, $link.text(), pValue, {
                            sub_sec: 'top-videos', cpos: pValue, pos: 1
                        }
                    );
                }
            }
        }
    };

    // Hook all top videos modules on the page
    $('.top-videos').topVideos();
})(jQuery);
